var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communities-Page",
    transform: "translate(-1112.000000, -532.000000)",
    fill: "#FA7319",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communities-Copy",
    transform: "translate(1035.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,12 C67.688,12 65,14.688 65,18 C65,21.312 67.688,24 71,24 C74.312,24 77,21.312 77,18 C77,14.688 74.312,12 71,12 Z M71.6,22.2 L70.4,22.2 L70.4,21 L71.6,21 L71.6,22.2 Z M72.842,17.55 L72.302,18.102 C71.87,18.54 71.6,18.9 71.6,19.8 L70.4,19.8 L70.4,19.5 C70.4,18.84 70.67,18.24 71.102,17.802 L71.846,17.046 C72.068,16.83 72.2,16.53 72.2,16.2 C72.2,15.54 71.66,15 71,15 C70.34,15 69.8,15.54 69.8,16.2 L68.6,16.2 C68.6,14.874 69.674,13.8 71,13.8 C72.326,13.8 73.4,14.874 73.4,16.2 C73.4,16.728 73.184,17.208 72.842,17.55 Z",
    id: "Shape-Copy"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8221bbca262825b244c90fc4378a38b2.svg";
export { ForwardRef as ReactComponent };